import { Controller } from "@hotwired/stimulus"

// We'll load Trix via CDN if not present
export default class extends Controller {
  static targets = ["editor"]

  connect() {
    this.disableFileUploads()
  }

  disableFileUploads() {
    // Prevent Trix from accepting file uploads
    document.addEventListener("trix-file-accept", (event) => {
      event.preventDefault()
      alert("Image uploads are not allowed in the description. Please use the 'Photos' section above.")
    })
  }
}
